import MainRoutesView from './main_routes_view';

export default MainRoutesView;
